import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig, APP_CONFIG } from '@app/app-config.module';

import { Observable } from 'rxjs';
import { timeout, retry } from 'rxjs/operators';
import { CheckCompanyCanUserServiceRequest, CompanyCanUseServiceDto, CreateService, GetServiceRequireIdentity, GetServiceRequireRole, ResultCheckCompanyCanUserService, SearchCompanyCanUserServiceRequest, ServiceInfo, ServiceRequireIdentityDto, ServiceRequireRoleDto, UpdateService, UpsertCompanyCanUseService, UpsertServiceRequireIdentity, UpsertServiceRequireRole, ServiceRequireGroupKycDto } from '../models/manage-service.model';
import { RegisterData } from '../models/register.model';
import { StandardResponse, StandardResponseList, StandardResponses2 } from '../models/standard-response.model';


@Injectable({
  providedIn: 'root'
})
export class ManageService {
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private http: HttpClient
  ) {}

  getService(): Observable<StandardResponses2<ServiceInfo>> {    
    return this.http
      .get<StandardResponses2<ServiceInfo>>(`${this.config.apiEndpoint}/manage-service/get-service`)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  createService(request:CreateService): Observable<StandardResponses2<ServiceInfo>> {    
    return this.http
      .post<StandardResponses2<ServiceInfo>>(`${this.config.apiEndpoint}/manage-service/create-service`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  updateService(request:UpdateService): Observable<StandardResponses2<UpdateService>> {    
    return this.http
      .post<StandardResponses2<UpdateService>>(`${this.config.apiEndpoint}/manage-service/update-service`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  upsertServiceRequireIdentity(request:UpsertServiceRequireIdentity): Observable<StandardResponses2<ServiceRequireIdentityDto[]>> {    
    return this.http
      .post<StandardResponses2<ServiceRequireIdentityDto[]>>(`${this.config.apiEndpoint}/manage-service/upsert-service-require-identity`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  getServiceRequireIdentity(request:GetServiceRequireIdentity): Observable<StandardResponseList<ServiceRequireIdentityDto>> {    
    return this.http
      .post<StandardResponseList<ServiceRequireIdentityDto>>(`${this.config.apiEndpoint}/manage-service/get-service-require-identity`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }
  
  getServiceRequireGroupKyc(request:GetServiceRequireIdentity): Observable<StandardResponseList<ServiceRequireGroupKycDto>> {    
    return this.http
      .post<StandardResponseList<ServiceRequireGroupKycDto>>(`${this.config.apiEndpoint}/group-kyc-identity/get-service-require-group-kyc`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  getServiceRequireRole(request:GetServiceRequireRole): Observable<StandardResponseList<ServiceRequireRoleDto>> {    
    return this.http
      .post<StandardResponseList<ServiceRequireRoleDto>>(`${this.config.apiEndpoint}/manage-service/get-service-require-role`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  upsertServiceRequireRole(request:UpsertServiceRequireRole): Observable<StandardResponses2<ServiceRequireRoleDto[]>> {    
    return this.http
      .post<StandardResponses2<ServiceRequireRoleDto[]>>(`${this.config.apiEndpoint}/manage-service/upsert-service-require-role`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiDigitalMailboxTimeout));
  }

  checkCompanyCanUseService(request:CheckCompanyCanUserServiceRequest): Observable<StandardResponse<ResultCheckCompanyCanUserService>> {    
    return this.http
      .post<StandardResponse<ResultCheckCompanyCanUserService>>(`${this.config.apiEndpoint}/manage-service/check-company-can-use-service`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }
  
  upsertCompanyCanUseService(request:UpsertCompanyCanUseService): Observable<StandardResponses2<CompanyCanUseServiceDto>> {    
    return this.http
      .post<StandardResponses2<CompanyCanUseServiceDto>>(`${this.config.apiEndpoint}/manage-service/upsert-company-can-use-service`,request)
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  listService(): Observable<StandardResponses2<ServiceInfo>> {
    return this.http
      .post<StandardResponses2<ServiceInfo>>(`${this.config.apiEndpoint}/manage-service/list-service`,'')
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  searchCompanyCanUseService(
    criteria:SearchCompanyCanUserServiceRequest,  
    pageNumber: number,
    pageSize: number
  ): Observable<StandardResponses2<CompanyCanUseServiceDto>> {
    return this.http
      .post<StandardResponses2<CompanyCanUseServiceDto>>(`${this.config.apiEndpoint}/manage-service/search-company-can-use-service`,
      {
        criteria: criteria,
        pageNumber: pageNumber,
        pageSize: pageSize,
      })
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

}
